import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../../shared/services/indexedDb.service';
import { InspectionPlugin } from '../../../shared/models';
import { Observable } from 'rxjs';
import { DataService } from '../../../shared/services';

@Injectable()
export class InstallationCheckedPluginFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateCheckedValues(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    checkedValues: any[],
    propertyName?: string
  ): Observable<InspectionPlugin> {
    checkedValues.forEach((r) => {
      if (!r.Id) {
        r.Id = this.guid();
      }
    });
    return this.updatePluginConfig(inspectionId, pointId, pluginId, checkedValues, propertyName);
  }
}
